export default function generateUUID() {
  const timestamp = Date.now().toString(36).slice(-4); // Toma los últimos 4 caracteres del timestamp en base 36
  const randomPart = Math.random().toString(36).substr(2, 4);
  return `${timestamp}${randomPart}`;
}
